export const ROUTES = {
  HOME: '/',
  GRADE_10: '/grade-10',
  GRADE_11: '/grade-11',
  CONTACTS: '/contacts',
} as const;

export const SUBJECT_ROUTES = {
  NATIONAL_DEFENSE: 'national-defense',
  MEDICINE: 'medicine',
} as const;
  
export const SUBJECTS = {
  NATIONAL_DEFENSE: 'Захист Вітчизни',
  MEDICINE: 'Основи медичних знань',
} as const;

export const GRADES = {
  GRADE_10: 10,
  GRADE_11: 11,
} as const;

export const LESSON_COUNTS = {
  GRADE_10: 8,
  GRADE_11: 8,
} as const;

export const DAY_COUNTS = {
  GRADE_10: 9,
  GRADE_11: 9,
} as const;
